import {
  Container,
  Grid,
  Typography,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { backend } from "../../api";
import { PageBanner } from "../../components";
import BookAdminCard from "../../components/BookCard/BookAdminCard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Skeleton } from "@material-ui/lab";
import BookKleverBookCard from "../../components/BookCard/BookKleverBookCard";
import { Pagination } from "@mui/material"; // Correct import

function AdminBook() {
  const state = useSelector((state) => state.shop);
  const [books, setBooks] = useState([]);
  const [kleverBooks, setKleverBooks] = useState([]);
  const [loadingBooks, setLoadingBooks] = useState(true);
  const [loadingKleverBooks, setLoadingKleverBooks] = useState(true);
  const [error, setError] = useState();
  const [currentView, setCurrentView] = useState("adminBooks");
  const [categories, setCategories] = useState([]);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const booksPerPage = 12; // Number of books per page
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchBooks();
    fetchKleverBooks();
  }, []);

  useEffect(() => {
    if (!loadingBooks && !loadingKleverBooks) {
      fetchCategories();
    }
  }, [loadingBooks, loadingKleverBooks]);

  const fetchBooks = () => {
    setLoadingBooks(true);
    backend
      .get("/book")
      .then((response) => {
        const filteredBooks = response.data.data.filter(
          (book) => book.isAuthorAdmin && book.isActive
        );
        setBooks(filteredBooks);
        setLoadingBooks(false);
      })
      .catch((error) => {
        console.error("Error fetching books:", error);
        setLoadingBooks(false);
        setError("Error fetching books");
      });
  };

  const fetchKleverBooks = () => {
    setLoadingKleverBooks(true);
    backend
      .get("/adverbook?isActive=true")
      .then(({ data }) => {
        const kleverBooks = data.data.filter(
          (book) =>
            book?.addToKlever === true &&
            book?.status[1]?.status === "approved" &&
            book?.isAuthorAdmin === true
        );
        setKleverBooks(kleverBooks);
        setLoadingKleverBooks(false);
        if (currentView === "kleverBooks") {
          fetchCategories();
        }
      })
      .catch((err) => {
        console.error("Error fetching kleverBooks:", err);
        setLoadingKleverBooks(false);
        setError("Error fetching kleverBooks");
      });
  };

  const fetchCategories = () => {
    setIsCategoriesLoading(true);
    backend
      .get("/category")
      .then(({ data }) => {
        const activeCategories = data.data.filter((cat) => cat.isActive);
        setCategories(activeCategories);
        setIsCategoriesLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setIsCategoriesLoading(false);
        setError("Error fetching categories");
      });
  };

  const handleCategoryChange = (event) => {
    const { name, checked } = event.target;

    setSelectedCategories((prevSelected) => {
      if (checked) {
        return [...prevSelected, name];
      } else {
        return prevSelected.filter((catId) => catId !== name);
      }
    });
  };

  const getFilteredBooks = () => {
    const booksToDisplay = currentView === "adminBooks" ? books : kleverBooks;
    return booksToDisplay.filter((book) => {
      const bookCategories = book.book_category.map((cat) => cat._id);
      return selectedCategories.length
        ? selectedCategories.some((selectedCat) =>
            bookCategories.includes(selectedCat)
          )
        : true;
    });
  };

  // Get current books based on active view
  const filteredBooks = getFilteredBooks();
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentDisplayBooks = filteredBooks.slice(
    indexOfFirstBook,
    indexOfLastBook
  );

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
    setIsCategoriesLoading(true);
    if (view === "adminBooks" && !loadingBooks) {
      setLoadingBooks(true);
      fetchBooks();
    } else if (view === "kleverBooks" && !loadingKleverBooks) {
      setLoadingKleverBooks(true);
      fetchKleverBooks();
    } else {
      fetchCategories();
    }
  };

  return (
    <Fragment>
      <Helmet>
        <title>Admin-Shop - d2p</title>
      </Helmet>
      <ToastContainer />
      {/* <PageBanner title="Shop" image="/assets/images/bg4.jpg" /> */}
      <Container style={{ marginTop: "120px", marginBottom: "15px" }}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={4} md={3}>
            {isCategoriesLoading ? (
              <Box mb={2} bgcolor="white" boxShadow={3} borderRadius={4} p={2}>
                <Skeleton animation="wave" height={40} width="80%" />
                <Skeleton animation="wave" height={40} />
                <Skeleton animation="wave" height={40} />
                <Skeleton animation="wave" height={40} />
              </Box>
            ) : (
              <Box mb={2} bgcolor="white" boxShadow={3} borderRadius={4} p={2}>
                <Typography variant="h6">Categories</Typography>
                <FormGroup>
                  {categories.map((category) => (
                    <FormControlLabel
                      key={category._id}
                      control={
                        <Checkbox
                          checked={selectedCategories.includes(category._id)}
                          onChange={handleCategoryChange}
                          name={category._id}
                        />
                      }
                      label={category.category_name}
                    />
                  ))}
                </FormGroup>
              </Box>
            )}
          </Grid>
          <Grid item xs={12} sm={8} md={9}>
            <Box display="flex" mb={2}>
              <Button
                variant={
                  currentView === "adminBooks" ? "contained" : "outlined"
                }
                style={{
                  color: currentView === "adminBooks" ? "#000" : "#FECE00",
                  backgroundColor:
                    currentView === "adminBooks" ? "#FECE00" : "transparent",
                  marginRight: "10px",
                }}
                onClick={() => handleViewChange("adminBooks")}
              >
                Admin Books
              </Button>
              <Button
                variant={
                  currentView === "kleverBooks" ? "contained" : "outlined"
                }
                style={{
                  color: currentView === "kleverBooks" ? "#000" : "#FECE00",
                  backgroundColor:
                    currentView === "kleverBooks" ? "#FECE00" : "transparent",
                }}
                onClick={() => handleViewChange("kleverBooks")}
              >
                KleverBook
              </Button>
            </Box>
            {(loadingBooks && currentView === "adminBooks") ||
            (loadingKleverBooks && currentView === "kleverBooks") ||
            isCategoriesLoading ? (
              <Grid container spacing={2}>
                {[...Array(12)].map((_, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={6} key={index}>
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      height={250}
                      width="100%"
                      style={{ marginBottom: "16px" }}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : currentDisplayBooks.length > 0 ? (
              <Grid container spacing={2}>
                {currentDisplayBooks.map((book, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={6} key={index}>
                    {currentView === "adminBooks" ? (
                      <BookAdminCard
                        title={book.book_title}
                        price={book.price ? book.price.digital_price : "Soon"}
                        cover={book.book_cover}
                        bookId={book._id}
                        preOrder={book.pre_order}
                      />
                    ) : (
                      <BookKleverBookCard
                        title={book.book_title}
                        cover={book.book_cover}
                        bookId={book._id}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box textAlign="center" mt={4}>
                <Typography variant="subtitle2">
                  {selectedCategories.length > 0
                    ? "No books found for the selected categories."
                    : "No books available."}
                </Typography>
              </Box>
            )}
            {filteredBooks.length > booksPerPage && (
              <Box display="flex" justifyContent="center" mt={4}>
                <Pagination
                  count={Math.ceil(filteredBooks.length / booksPerPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#FECE00",
                      },
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#FECE00",
                      color: "#000",
                    },
                    "& .MuiPaginationItem-ellipsis": {
                      color: "#FECE00",
                    },
                  }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
}

export default AdminBook;
